package tta.destinigo.talktoastro.feature_call_consultation.data.api

import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.request.url
import tta.destinigo.talktoastro.feature_call_consultation.data.request.JoinQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.request.RemoveQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.request.ValidateQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.JoinQueueData
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.JoinQueueResponse
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.QueueStatusRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status.QueueStatusData
import tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status.QueueStatusResponse
import tta.destinigo.talktoastro.feature_call_consultation.data.response.remove_queue.RemoveQueueResponse
import tta.destinigo.talktoastro.feature_call_consultation.data.response.validate_queue.ValidateQueueResponse
import tta.destinigo.talktoastro.shared.remote.KtorApi
import tta.destinigo.talktoastro.shared.remote.Resources
import tta.destinigo.talktoastro.shared.remote.makeApiCall

class QueueApiServiceImplementation: QueueApiService,KtorApi() {

    companion object{
        private const val QUEUE_PREFIX = "queue/"
        private const val QUEUE_JOIN = QUEUE_PREFIX + "add"
        private const val QUEUE_REMOVE = QUEUE_PREFIX + "remove"
        private const val QUEUE_STATUS_DATA = QUEUE_PREFIX + "dialog-box-data"
        private const val QUEUE_STATUS_VALIDATE = QUEUE_PREFIX + "validate"
    }

    private suspend fun queueStatusApi(request: QueueStatusRequest)= client.get {
        url(QUEUE_STATUS_DATA)
    }.body<QueueStatusResponse>()

    private suspend fun validateQueue(request: ValidateQueueRequest)= client.post {
        url(QUEUE_STATUS_VALIDATE)
        setBody(request)
    }.body<ValidateQueueResponse>()

    private suspend fun joinApi(request: JoinQueueRequest)= client.post {
        url(QUEUE_JOIN)
        setBody(request)
    }.body<JoinQueueResponse>()

    private suspend fun removeApi(request: RemoveQueueRequest)= client.post {
        url(QUEUE_REMOVE)
        setBody(request)
    }.body<RemoveQueueResponse>()

    override suspend fun onJoinQueue(request: JoinQueueRequest): Resources<JoinQueueData?> {
        return makeApiCall(
            apiCall = {joinApi(request)},
            transform = {it.data}
        )
    }

    override suspend fun onRemoveQueue(request: RemoveQueueRequest): Resources<String?> {
        return  makeApiCall(
            apiCall = {removeApi(request)},
            transform = {it.data}
        )
    }

    override suspend fun getQueueStatus(request: QueueStatusRequest): Resources<List<QueueStatusData>?> {
        return makeApiCall(
            apiCall = {queueStatusApi(request)},
            transform = {it.data}
        )
    }

    override suspend fun validateQueueStatus(request: ValidateQueueRequest): Resources<ValidateQueueResponse?> {
        return makeApiCall(
            apiCall = {validateQueue(request)},
            transform = {it}
        )
    }
}